/* Cart-drawer "Complete the Flora & Fauna collection" (James, 2026-09-18).
   When the cart holds at least one cushion from the smart collection flora-and-fauna-cushions and
   others from it are missing, the missing ones are offered below Recently Viewed with the usual +
   quick-add, plus an "Add all" button. Same mechanics as bokja-cart-pair.js: tiles come from the
   bokja-recently-viewed section renderer; adds go through window.BokjaCartAdd (bokja-wishlist-add.js)
   so the drawer morphs and the next pass hides what is now in the cart. Fail-safe: any error hides
   the strip and never touches the cart. */
(function () {
  if (window.__bokjaCartCompleteBound) return;
  window.__bokjaCartCompleteBound = true;
  var COLLECTION = '/collections/flora-and-fauna-cushions/products.json?limit=50';
  var set = null;          // [{ handle, id (product), variant, available }]
  var lastKey = null;
  var loading = false;

  async function loadSet() {
    if (set) return set;
    var j = await (await fetch(COLLECTION, { headers: { Accept: 'application/json' } })).json();
    set = (j.products || []).map(function (p) {
      var v = (p.variants || []).find(function (x) { return x.available; }) || (p.variants || [])[0];
      return { handle: p.handle, id: p.id, variant: v && v.id, available: !!(v && v.available) };
    });
    return set;
  }

  async function load() {
    if (window.__bokjaCartBusy) return;
    if (loading) return;
    var wrap = document.querySelector('[data-bokja-cart-complete]');
    var mount = wrap && wrap.querySelector('.bokja-recents__mount');
    var all = wrap && wrap.querySelector('[data-bokja-cart-complete-all]');
    if (!wrap || !mount) return;
    loading = true;
    try {
      var s = await loadSet();
      var cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      var inCart = cart.items.map(function (i) { return i.handle; });
      var hasOne = s.some(function (p) { return inCart.indexOf(p.handle) !== -1; });
      var missing = s.filter(function (p) { return p.available && inCart.indexOf(p.handle) === -1; });
      if (!hasOne || !missing.length) { wrap.hidden = true; lastKey = null; return; }
      var key = missing.map(function (p) { return p.handle; }).join(',');
      if (all) all.dataset.variants = missing.map(function (p) { return p.variant; }).join(',');
      if (key === lastKey && mount.children.length) { wrap.hidden = false; return; }
      var q = missing.map(function (p) { return 'id:' + p.id; }).join(' OR ');
      var res = await fetch('/search?type=product&q=' + encodeURIComponent(q) + '&section_id=bokja-recently-viewed', { headers: { Accept: 'text/html' } });
      if (!res.ok) { wrap.hidden = true; return; }
      mount.innerHTML = (await res.text()).trim();
      var has = !!mount.querySelector('.bokja-recents__cell');
      wrap.hidden = !has;
      lastKey = has ? key : null;
    } catch (e) {
      wrap.hidden = true;
    } finally {
      loading = false;
    }
  }

  var debounce = null;
  function schedule() { clearTimeout(debounce); debounce = setTimeout(load, 350); }

  var obs = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var d = muts[i].target;
      if (d.nodeType === 1 && d.classList && d.classList.contains('cart-drawer__dialog') && d.hasAttribute('open')) schedule();
    }
  });
  var itemsObs = new MutationObserver(function () { schedule(); });
  function watch() {
    var dlg = document.querySelector('.cart-drawer__dialog');
    if (dlg && !dlg.__bokjaCompleteWatched) {
      dlg.__bokjaCompleteWatched = true;
      obs.observe(dlg, { attributes: true, attributeFilter: ['open'] });
      if (dlg.hasAttribute('open')) schedule();
    }
    var items = document.querySelector('.cart-drawer__items');
    if (items && !items.__bokjaCompleteWatched) {
      items.__bokjaCompleteWatched = true;
      itemsObs.observe(items, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.bokja-nav__cart--trigger, [data-testid="cart-drawer-trigger"], [data-bokja-quickadd]');
    if (t) { watch(); setTimeout(schedule, 400); }
  }, true);

  // 2026-09-18 (James): the drawer can open by itself after an add and its dialog can be rebuilt, so the
  // [open] observer above is not enough. Three more triggers: the theme's own cart event, an [open]
  // observer over the whole page, and a quiet re-check every 4 s while the drawer is open.
  document.addEventListener('cart:update', function () { watch(); setTimeout(load, 400); });
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) { var d = muts[i].target; if (d.nodeType === 1 && d.classList && d.classList.contains('cart-drawer__dialog') && d.hasAttribute('open')) { watch(); setTimeout(load, 300); } }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['open'], subtree: true });
  setInterval(function () { if (document.querySelector('.cart-drawer__dialog[open]')) { watch(); load(); } }, 4000);

  // Add all: the missing variants, one after another through the same quick-add the + uses.
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest && e.target.closest('[data-bokja-cart-complete-all]');
    if (!btn || !window.BokjaCartAdd) return;
    e.preventDefault();
    var ids = (btn.dataset.variants || '').split(',').filter(Boolean);
    if (!ids.length || btn.disabled) return;
    btn.disabled = true;
    window.__bokjaCartBusy = true;   // the strips and the recents stay quiet until the one morph is done
    try {
      if (window.BokjaCartAddMany) { await window.BokjaCartAddMany(ids, btn); }
      else { for (var i = 0; i < ids.length; i++) { try { await window.BokjaCartAdd(ids[i], btn); } catch (err) { /* one failure never stops the rest */ } } }
    } finally {
      btn.disabled = false;
      setTimeout(function () { window.__bokjaCartBusy = false; schedule(); }, 600);
    }
  });
})();
